import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { ChannelFilter } from "../filters/marketing-channel-filter";
import { MarketingAnalyticsAudienceGrowth } from "./marketing-analytics-audience-growth";

export const MarketingAnalyticsAudience = memo(
  function MarketingAnalyticsAudience({
    dateFilter,
    channelFilter,
  }: {
    dateFilter: [Temporal.PlainDate, Temporal.PlainDate] | undefined;
    channelFilter: ChannelFilter;
  }) {
    return (
      <Flex dir="column" gap="4xl" pb="8xl" w="full">
        <MarketingAnalyticsAudienceGrowth
          channelFilter={channelFilter}
          dateFilter={dateFilter}
        />
      </Flex>
    );
  },
);
